import { render, staticRenderFns } from "./discontentPointsModal.vue?vue&type=template&id=686fbd30&scoped=true&"
import script from "./discontentPointsModal.vue?vue&type=script&lang=js&"
export * from "./discontentPointsModal.vue?vue&type=script&lang=js&"
import style0 from "./discontentPointsModal.vue?vue&type=style&index=0&id=686fbd30&lange=less&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686fbd30",
  null
  
)

export default component.exports